/**
 * SEO para las páginas públicas de Seway Plus Negocios.
 *
 * El proyecto no usa vue-meta ni unhead, así que las etiquetas se inyectan a mano.
 * Todas las que crea este módulo quedan marcadas con data-sp-seo para poder
 * retirarlas al salir de la página y no contaminar el resto del ERP.
 *
 * Limitación conocida: el router va en createWebHashHistory, de modo que la URL es
 * .../#/negocios y el fragmento nunca llega al servidor. Estas etiquetas mejoran el
 * compartido en redes y el título del navegador, pero la indexación real seguirá
 * siendo limitada mientras no se migre a history mode con rewrite en el servidor.
 */

const TITULO_ERP = 'SEWAY-PLUS-ERP';
const MARCA = 'data-sp-seo';

function fijarEtiqueta(selector, crear, contenido) {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = crear();
        el.setAttribute(MARCA, '');
        document.head.appendChild(el);
    }
    el.setAttribute(contenido.attr, contenido.valor);
    return el;
}

function meta(nombre, valor, porPropiedad) {
    const clave = porPropiedad ? 'property' : 'name';
    fijarEtiqueta(
        'meta[' + clave + '="' + nombre + '"]',
        () => {
            const el = document.createElement('meta');
            el.setAttribute(clave, nombre);
            return el;
        },
        { attr: 'content', valor: valor }
    );
}

/** Convierte una ruta relativa a public/ en URL absoluta respetando BASE_URL. */
export function urlAbsoluta(rutaRelativa) {
    try {
        return new URL(rutaRelativa, document.baseURI).href;
    } catch (e) {
        return rutaRelativa;
    }
}

export function aplicarSeo(opciones) {
    const titulo = opciones.titulo;
    const descripcion = opciones.descripcion;
    const imagen = opciones.imagen ? urlAbsoluta(opciones.imagen) : null;
    const url = window.location.href;

    document.title = titulo;
    document.documentElement.setAttribute('lang', 'es');

    meta('description', descripcion);
    meta('robots', 'index, follow');

    meta('og:type', 'website', true);
    meta('og:site_name', 'Seway Plus', true);
    meta('og:title', titulo, true);
    meta('og:description', descripcion, true);
    meta('og:url', url, true);
    if (imagen) meta('og:image', imagen, true);

    meta('twitter:card', imagen ? 'summary_large_image' : 'summary');
    meta('twitter:title', titulo);
    meta('twitter:description', descripcion);
    if (imagen) meta('twitter:image', imagen);

    fijarEtiqueta(
        'link[rel="canonical"]',
        () => {
            const el = document.createElement('link');
            el.setAttribute('rel', 'canonical');
            return el;
        },
        { attr: 'href', valor: url }
    );
}

/** Deja el <head> como estaba antes de entrar a la landing. */
export function limpiarSeo() {
    document.title = TITULO_ERP;
    const creadas = document.head.querySelectorAll('[' + MARCA + ']');
    for (let i = 0; i < creadas.length; i++) {
        creadas[i].parentNode.removeChild(creadas[i]);
    }
}
